import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonInput, IonPage, IonToolbar } from '@ionic/react';
import { close, search } from 'ionicons/icons';
import React, { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import EstablishmentList from '../../components/EstablishmentCards/general';
import GeneralSkeletonText from '../../components/skeleton_text/general_establishment';
import axios from '../../helpers/axiosInterceptor';


const Home: React.FC = (props: any) => {

	const [establishments, setEstablishments] = useState([]);
	const [status, setStatus] = useState({
		searching: false,
		loaded: false,
		error: ''
	});
	const [query, setQuery] = useState("");

	const onSearch = (e) => {
		const q = e.target.value
		setQuery(q);
		if (q.trim().length < 3 || status.searching)
			return

		setStatus({ ...status, searching: true });

		axios.post('/establishments/search', { q })
			.then(res => {
				setEstablishments(res.data);
				setStatus({ ...status, loaded: true, searching: false });
			})
			.catch(err => {
				setStatus({ ...status, loaded: true, error: err, searching: false });
			})
	}


	return (
		<IonPage>

			<IonHeader className="bg-white ion-no-border border-bottom">
				<IonToolbar color="white">
					<IonButtons slot="primary">
						<IonButton onClick={() => setQuery('')}>
							<IonIcon icon={close} className="text-muted" />
						</IonButton>
					</IonButtons>
					<IonButtons slot="start">
						<IonButton>
							<IonIcon icon={search} className="text-muted" />
						</IonButton>
					</IonButtons>

					<IonInput onIonChange={onSearch} value={query} placeholder="Search for Establishment and Products" className="font-weight-bold text-default">
					</IonInput>
				</IonToolbar>
			</IonHeader>


			<IonContent fullscreen>

				<Container fluid={true} className="h-100">
					{(establishments.length === 0 && !status.searching) && (
						<Row className="d-flex align-items-center h-100">
							<Col className="px-7 py-2 col mt-n5">
								<img className="dull-filter" src={require('../../assets/img/icons/common/search-establishment.svg')} alt="search-establishment" />
							</Col>
						</Row>
					)}

					{status.searching && (
						<Row className="mt-3">
							<Col>
								{[...Array(5)].map((e, i) => (<GeneralSkeletonText key={i} />))}
							</Col>
						</Row>
					)}
					{(status.loaded && !status.searching && establishments.length !== 0) && (
						<Row className="mt-3">
							<Col>
								<h5 className="font-weight-bold px-3">Search Results</h5>
								<EstablishmentList history={props.history} establishments={establishments} />
							</Col>
						</Row>
					)}

				</Container>
			</IonContent>


		</IonPage>
	);
};

export default Home;
